export default __webpack_public_path__ + "static/media/gallery - story - hand (1)_02.993170fb.jpg";